$(document).ready(function() {

    function swapActiveState(element) {
        if (element.hasClass('active')) {
            element.removeClass('active');
        } else {
            element.addClass('active');
        }
    }

    $.fn.hasAttr = function (name) {
        return this.attr(name) !== undefined;
    };

    $('.delete-address').click(function () {
        $('#deleteAddressId').val($(this).attr('address-id'));
    });

    /* START - Mobile Account Menu */

    let $window = $(window), $mobileAccountMenu = $('.mobile-menu.account');

    $window.resize(function resize() {
        if ($window.width() > 767) {
            return $mobileAccountMenu.removeClass('active');
        }
    }).trigger('resize');

    $('.account-navbar-toggle').click(function () {
        //collapseMobileMainMenu
        if ($('.mobile-menu').not('.account').hasClass('active')) {
            $('.navbar-toggle').trigger('click');
        }
        swapActiveState($mobileAccountMenu);
    });

    $('.navbar-toggle').click(function () {
        if ($mobileAccountMenu.hasClass('active')) {
            swapActiveState($mobileAccountMenu);
        }
    });

    // Show submenu when first touch is detected
    window.addEventListener('touchstart', function() {
        $('.dropdown .main-menu-item').click(function (event) {
            if (!$(this).hasClass('clicked')) {
                event.preventDefault();

                $('.dropdown .main-menu-item').each(function () {
                    $(this).removeClass('clicked');
                });

                $(this).addClass('clicked');
            }
        });
    });
});

